// extracted by mini-css-extract-plugin
export default {"root":"IconGlobe_root__Q+r9b","icon":"IconGlobe_icon__kHg9U"};